Object.defineProperty(exports, "__esModule", {
  value: true
});

var _findDOMNode = require('react/lib/findDOMNode');

var _findDOMNode2 = _interopRequireDefault(_findDOMNode);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _findDOMNode2.default;